var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCharactersArtifactsMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 374,
    height: 1112,
    viewBox: "0 0 374 1112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.4,
    y: 244.9,
    className: "st0",
    width: 1.1,
    height: 1.7,
    fill: "#E9ABE1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.4,
    y: 250.6,
    className: "st0",
    width: 1.1,
    height: 1.7,
    fill: "#E9ABE1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.2,
    y: 244.9,
    className: "st0",
    width: 1.1,
    height: 1.7,
    fill: "#E9ABE1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 31.2,
    y: 250.6,
    className: "st0",
    width: 1.1,
    height: 1.7,
    fill: "#E9ABE1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 53.3,
    y: 205.8,
    className: "st0",
    width: 1.1,
    height: 1.7,
    fill: "#E9ABE1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 296.8,
    className: "st0",
    width: 4,
    height: 4,
    fill: "#E9ABE1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 296.8,
    className: "st0",
    width: 0.6,
    height: 1.7,
    fill: "#E9ABE1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 64.3,
    y: 296.8,
    className: "st0",
    width: 0.6,
    height: 1.7,
    fill: "#E9ABE1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 28.4,
    y: 205.8,
    className: "st0",
    width: 1.1,
    height: 1.7,
    fill: "#E9ABE1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 95.1,
    className: "st0",
    width: 1.1,
    height: 1.7,
    fill: "#E9ABE1"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 253.1,
    y: 95.1,
    className: "st0",
    width: 1.1,
    height: 1.7,
    fill: "#E9ABE1"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 166.1,
    y: 95.1,
    className: "st0",
    width: 1.1,
    height: 1.7,
    fill: "#E9ABE1"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 253.3,
    y: 410.9,
    className: "st0",
    width: 1.1,
    height: 1.7,
    fill: "#E9ABE1"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 252.7,
    y: 367.4,
    className: "st0",
    width: 1.1,
    height: 1.7,
    fill: "#E9ABE1"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 53.8,
    y: 249.4,
    className: "st0",
    width: 1.1,
    height: 1.7,
    fill: "#E9ABE1"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 345.4,
    y: 205.9,
    className: "st0",
    width: 1.1,
    height: 1.7,
    fill: "#E9ABE1"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 345.4,
    y: 211.5,
    className: "st0",
    width: 1.1,
    height: 1.7,
    fill: "#E9ABE1"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 342.6,
    y: 205.9,
    className: "st0",
    width: 1.1,
    height: 1.7,
    fill: "#E9ABE1"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 342.6,
    y: 211.5,
    className: "st0",
    width: 1.1,
    height: 1.7,
    fill: "#E9ABE1"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 205.3,
    className: "st0",
    width: 1.1,
    height: 1.7,
    fill: "#E9ABE1"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 67.7,
    y: 323.9,
    className: "st0",
    width: 4,
    height: 4,
    fill: "#E9ABE1"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 323.9,
    className: "st0",
    width: 0.6,
    height: 1.7,
    fill: "#E9ABE1"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 59.8,
    y: 323.9,
    className: "st0",
    width: 0.6,
    height: 1.7,
    fill: "#E9ABE1"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 317.1,
    y: 296.8,
    className: "st0",
    width: 4,
    height: 4,
    fill: "#E9ABE1"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 311.5,
    y: 296.8,
    className: "st0",
    width: 0.6,
    height: 1.7,
    fill: "#E9ABE1"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 309.2,
    y: 296.8,
    className: "st0",
    width: 0.6,
    height: 1.7,
    fill: "#E9ABE1"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 302.4,
    y: 323.9,
    className: "st0",
    width: 4,
    height: 4,
    fill: "#E9ABE1"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 311.5,
    y: 323.9,
    className: "st0",
    width: 0.6,
    height: 1.7,
    fill: "#E9ABE1"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 313.7,
    y: 323.9,
    className: "st0",
    width: 0.6,
    height: 1.7,
    fill: "#E9ABE1"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 121.1,
    y: 367.4,
    className: "st0",
    width: 1.1,
    height: 1.7,
    fill: "#E9ABE1"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 121.1,
    y: 410.9,
    className: "st0",
    width: 1.1,
    height: 1.7,
    fill: "#E9ABE1"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 295.7,
    y: 204.7,
    className: "st0",
    width: 1.1,
    height: 5.1,
    fill: "#E9ABE1"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 270.2,
    y: 204.2,
    className: "st0",
    width: 1.1,
    height: 5.1,
    fill: "#E9ABE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharactersArtifactsMobile);
export default __webpack_public_path__ + "static/media/characters-artifacts-mobile.11b791d3c1efb60ec8f34f3e6b908ef6.svg";
export { ForwardRef as ReactComponent };